import { useContext } from 'react';

import { LocaleContext } from './LocaleContext';
import type { LocaleContextValue } from './LocaleContext';

export function useLocale(): LocaleContextValue {
  const ctx = useContext(LocaleContext);
  if (!ctx) {
    throw new Error('useLocale must be used within LocaleProvider');
  }
  return ctx;
}
